import { render, staticRenderFns } from "./ComponentContainer.vue?vue&type=template&id=35fb39fc&scoped=true"
import script from "./ComponentContainer.vue?vue&type=script&lang=js"
export * from "./ComponentContainer.vue?vue&type=script&lang=js"
import style0 from "./ComponentContainer.vue?vue&type=style&index=0&id=35fb39fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fb39fc",
  null
  
)

export default component.exports